import React from "react";
import { useSelector } from 'react-redux';
import styles from "./PrintLink.module.css";


const PrintLink = () => {
    // Use the useSelector hook to access the 'specifier' state from the 'visualizer'(ready event) slice
    let specifier = useSelector((state) => state.visualizer.specifier);

    // Use the useSelector hook to access the 'selString' state from the 'visualizer'(surface_apply_done event) slice
    let selString = useSelector((state) => state.visualizer.selString);

    // Destructure protocol, host, from the current window location
    const { protocol, host } = window.location;
    const prodData = useSelector((state) => state.visualizer.productDataBySeries[8552])

    let printLink = `#`;
    console.log(selString)
    if(selString.length > 1){
        let data = null;
        let id = selString.split('(')[0];

        for (const obj of prodData) {
          if (obj.id == id) {
            data = obj;
            break;
          }
        }

        if(data)
          printLink = `/print.html?spec=${encodeURIComponent(specifier)}&sel=${selString}&name=${data.name}&color=${data.color}`;
    }
    
    

    return (
      printLink !== '#' ? (
        <a href={printLink} target="_blank" rel="noopener noreferrer">
          Print
        </a>
      ) : (
        <a href="#" onClick={(e) => {
          e.preventDefault(); // Prevent navigation
          alert("Please select atleast 1 product.");
        }}>
          Print
        </a>
      )
    );
    
    
};

export default PrintLink;